import React from "react";
import { useHistory } from "react-router-dom";
import { useStore } from "../../../store";
// TODO: ContentFormatter is unnecessary here - dangerouslySet shuold be used
import {
  ContentFormatter,
  Flex,
  Icon,
  Type,
  useMediaQuery,
} from "discover.medical.react-component-library";
import {
  DrugInteractionDetailsContainer,
  DrugInteractionDetailsDivider,
  DrugInteractionDetailsBackLink,
  DrugInteractionDetailsHeader,
} from "./styled";
import DrugInteractionsError from "../Error";

export const DrugInteractionsDetails = () => {
  const { drugInteractions } = useStore();
  const history = useHistory();

  const isMobile = useMediaQuery("max", "sm");

  const { viewModel, error, metaData } = drugInteractions.drugDetail;
  const backAction = viewModel?.back || error?.back;

  const { severity, interactingDrugName } = metaData;

  const handleBackLinkClick = () => history.push("/browse/drug-interactions");

  const backLinkSection = (
    <>
      <Flex container>
        {backAction && (
          <DrugInteractionDetailsBackLink
            data-testid="back-to-checker"
            kind="anchor"
            onClick={handleBackLinkClick}
          >
            <Icon icon={backAction.icon} />
            {backAction.name}
          </DrugInteractionDetailsBackLink>
        )}
      </Flex>
      <DrugInteractionDetailsDivider horizontal noMargin />
    </>
  );

  if (error) {
    return (
      <DrugInteractionDetailsContainer data-testid="di-details-error">
        {backLinkSection}
        <DrugInteractionsError
          viewModel={error.errorObject}
        ></DrugInteractionsError>
      </DrugInteractionDetailsContainer>
    );
  }

  return (
    <>
      <DrugInteractionDetailsContainer data-testid="di-details">
        {backLinkSection}
        {viewModel?.content && (
          <>
            <Flex
              container
              data-testid="di-details-header-data"
              column={isMobile}
              justify={{ content: "space-between" }}
            >
              <DrugInteractionDetailsHeader
                element="h2"
                color="primary"
                fontFamily="secondary"
                marginBottom="md"
              >
                {interactingDrugName.toUpperCase()}
              </DrugInteractionDetailsHeader>

              {severity && (
                <Flex cell>
                  <Flex container align={{ item: "center" }}>
                    <Icon
                      icon={{ ...severity.icon, size: "md" }}
                      background={{ color: severity.icon.background }}
                    />
                    <Type
                      fontSize="xs"
                      color="gray700"
                      fontWeight="semibold"
                      textTransform="uppercase"
                      marginLeft="sm"
                    >
                      {severity.title}
                    </Type>
                  </Flex>
                </Flex>
              )}
            </Flex>
            <ContentFormatter>{viewModel.content}</ContentFormatter>
          </>
        )}
      </DrugInteractionDetailsContainer>
    </>
  );
};

DrugInteractionsDetails.displayName = "DrugInteractionsDetails";
